module.exports = __webpack_public_path__ + "static/html-element-advanced_3-104e567f878fdd589a831a2c2c2e2d84.jpg";